export const manifest = {
  screens: {
    scr_3rjnrn: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_zo5of5: { name: "Home – Story open", route: "/", state: {"storyOpen":true}, position: {"x":1560,"y":220} },
    scr_xj0gf7: { name: "Your 4-step journey", route: "/#journey", position: {"x":160,"y":2200} },
    scr_t318e4: { name: "Offerings", route: "/#offerings", position: {"x":1560,"y":2200} },
    scr_9vgjx2: { name: "Retreat waitlist", route: "/#offerings", state: {"waitlistOpen":true}, position: {"x":2960,"y":2200} },
    scr_nzlxis: { name: "Reviews", route: "/#reviews", position: {"x":4360,"y":2200} },
    scr_2xfh6d: { name: "About me", route: "/#about", position: {"x":5760,"y":2200} },
    scr_7wop1r: { name: "About me – Full story", route: "/#about", state: {"aboutExpanded":true}, position: {"x":7160,"y":2200} },
    scr_8cyo2j: { name: "Contact", route: "/#contact", position: {"x":8560,"y":2200} },
    scr_ocfzym: { name: "Founding offer (/start)", route: "/start", position: {"x":160,"y":4180} },
    scr_8cewbw: { name: "Privacy policy", route: "/privacy", position: {"x":1560,"y":4180} },
  },
  sections: {
    sec_bsg0tt: { name: "Home", x: 0, y: 0, width: 2920, height: 1180 },
    sec_paw6ns: { name: "Home sections", x: 0, y: 1980, width: 9920, height: 1180 },
    sec_pkknuj: { name: "Secondary pages", x: 0, y: 3960, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_bsg0tt", children: [
      { kind: "screen", id: "scr_3rjnrn" },
      { kind: "screen", id: "scr_zo5of5" },
    ] },
    { kind: "section", id: "sec_paw6ns", children: [
      { kind: "screen", id: "scr_xj0gf7" },
      { kind: "screen", id: "scr_t318e4" },
      { kind: "screen", id: "scr_9vgjx2" },
      { kind: "screen", id: "scr_nzlxis" },
      { kind: "screen", id: "scr_2xfh6d" },
      { kind: "screen", id: "scr_7wop1r" },
      { kind: "screen", id: "scr_8cyo2j" },
    ] },
    { kind: "section", id: "sec_pkknuj", children: [
      { kind: "screen", id: "scr_ocfzym" },
      { kind: "screen", id: "scr_8cewbw" },
    ] },
  ],
}
